import { render, staticRenderFns } from "./ScSalesReport.vue?vue&type=template&id=553c222f"
import script from "./ScSalesReport.vue?vue&type=script&lang=js"
export * from "./ScSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports